
import { useScrollAnimation, getAnimationClass } from '../../../hooks/useScrollAnimation';

function AnimatedSection({ children, animation = 'slide-up' as 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in', className = '' }: { children: React.ReactNode; animation?: 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in'; className?: string }) {
  const { ref, isVisible } = useScrollAnimation();
  return (
    <div ref={ref} className={`${getAnimationClass(isVisible, animation)} ${className}`}>
      {children}
    </div>
  );
}

export default function AboutHero() {
  return (
    <section className="relative pt-32 pb-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20emerald%20green%20gradient%20background%20with%20soft%20geometric%20shapes%20and%20light%20particles%20futuristic%20technology%20company%20headquarters%20aesthetic%20deep%20dark%20tones%20with%20subtle%20green%20glow%20elegant%20corporate%20atmosphere&width=1920&height=700&seq=about-hero-bg-1&orientation=landscape"
          alt="La Millefera Tech background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <AnimatedSection animation="fade-in">
          <span className="inline-block text-xs font-semibold text-emerald-300 uppercase tracking-widest mb-4">Sobre Nosotros</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
            Innovación tecnológica al servicio de la
            <span className="font-display italic text-emerald-400"> salud visual</span>
          </h2>
          <p className="text-base text-white/80 max-w-2xl mx-auto leading-relaxed">
            La Millefera Tech LLC nació con una misión clara: transformar la gestión clínica oftalmológica a través de software inteligente, accesible y seguro.
          </p>
        </AnimatedSection>

        <AnimatedSection animation="slide-up">
          <div className="grid grid-cols-3 gap-8 mt-14 max-w-xl mx-auto">
            {[
              { value: '2023', label: 'Fundación' },
              { value: '500+', label: 'Profesionales' },
              { value: '12', label: 'Países' },
            ].map((stat, i) => (
              <div key={i} className="text-center">
                <p className="text-3xl font-bold text-white">{stat.value}</p>
                <p className="text-xs text-white/60 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
